var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-title',{staticClass:"subtitle-1 font-weight-bold d-flex align-center pt-0 pl-2"},[_c('v-avatar',{staticClass:"mr-3 white--text text-caption font-weight-bold",attrs:{"color":"primary","size":"24"}},[_vm._v(" "+_vm._s(_vm.step)+" ")]),_vm._v(" "+_vm._s(_vm.title)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }